export default "__VITE_ASSET__Bm$Pf4vI__"